import { SendingStatus } from '../types';

export const myJobsKeys = {
    all: [ 'myJobs' ] as const,

    lists: () => [ ...myJobsKeys.all, 'list' ] as const,

    list: (statuses?: SendingStatus[], pageNum?: number, pageSize?: number) =>
    [ ...myJobsKeys.lists(), { statuses, pageNum, pageSize } ] as const,

    externalLists: () => [ ...myJobsKeys.all, 'external' ] as const,

    externalList: (
        type: 'currentFuture' | 'past',
        pageNum: number,
        pageSize: number
    ) =>
    [ ...myJobsKeys.externalLists(), { type, pageNum, pageSize } ] as const,

    details: () => [ ...myJobsKeys.all, 'detail' ] as const,

    detail: (id: string) =>
    [ ...myJobsKeys.details(), id ] as const,

    counters: () =>
    [ ...myJobsKeys.all, 'counters' ] as const
};
